import { Component, OnInit, Inject, TemplateRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ComponentType } from '@angular/cdk/portal/index';
import { ApiService } from 'src/app/shared/services/api.service';
import { ToastrService } from 'ngx-toastr';
import AppResponseError from 'src/app/shared/models/app-response-error';
import { FormGroup, FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {

  public form: FormGroup;
  constructor(
    private apiService: ApiService,
    private toastr: ToastrService,
    protected dialogRef: MatDialogRef<ComponentType<any> | TemplateRef<any>>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    this.form = new FormGroup({
      email: new FormControl(undefined, [Validators.email])
    });
  }

  close(): void {

  }

  sendEmail(): void {
    if (!this.form.get('email').value) {
      this.toastr.error('Preencha o email', 'Erro!', { timeOut: 2000 });
      return;
    } else if (!this.form.get('email').valid) {
      this.toastr.error('email inválido', 'Erro!', { timeOut: 2000 });
      return;
    }

    if(this.data.acaoAreaLogada)
    {
      this.apiService.alterarSenha(this.form.get('email').value)
      .subscribe(
        response => {
          this.toastr.info(response, 'Ok!', { timeOut: 4000 });
          this.dialogRef.close();
        },
        (err: AppResponseError) => {
          this.toastr.error(err.descricao, err.titulo, { timeOut: 2000 });
        }
      );
    }
    else
    {
      this.apiService.recuperarSenha(this.form.get('email').value)
        .subscribe(
          response => {
            this.toastr.info(response, 'Ok!', { timeOut: 4000 });
            this.dialogRef.close();
          },
          (err: AppResponseError) => {
            this.toastr.error(err.descricao, err.titulo, { timeOut: 2000 });
          }
        );
    }
  }

  dismiss(): void {
    this.dialogRef.close();
  }
}




